import api from "./api";
import fetchHistoryPage from "./history";

const PDF_ENDPOINT = "partner/prescription/pdf";

export const PdfDownloadStatus = {
  Success: "success",
  Unavailable: "unavailable",
  ServiceUnavailable: "service_unavailable",
  Error: "error",
};

const SERVICE_UNAVAILABLE_STATUSES = [502, 503, 504];

// Download via GET com ticket efêmero (?ticket=<pdf_access>). Baixamos como blob
// para nomear o arquivo e manter a credencial fora da barra de endereço.
const getPrescriptionPdf = (ticket) =>
  api.get(PDF_ENDPOINT, {
    params: { ticket },
    responseType: "blob",
  });

// O pdf_access tem TTL curto e expira enquanto a lista fica aberta -> usar o
// token que veio no histórico daria 401 na cara. Por isso buscamos SEMPRE um
// token novo no momento do download, refazendo apenas a página de origem da
// prescrição (offset carimbado no histórico).
const resolvePdfAccess = async (idPrescription, offset) => {
  const { prescriptions } = await fetchHistoryPage({ offset });
  const match = (prescriptions || []).find(
    (prescription) => prescription.id === idPrescription
  );

  return match?.document?.pdf_access ?? null;
};

const statusFromError = (error) =>
  SERVICE_UNAVAILABLE_STATUSES.includes(error?.response?.status)
    ? PdfDownloadStatus.ServiceUnavailable
    : PdfDownloadStatus.Error;

// Resultado tipado (nunca lança): o hook decide a mensagem a partir do status.
// blob já vem com o content-type do servidor (application/pdf ou application/x-zip).
const downloadPrescriptionPdf = async ({ idPrescription, offset }) => {
  try {
    const pdfAccess = await resolvePdfAccess(idPrescription, offset);

    if (!pdfAccess) {
      return { status: PdfDownloadStatus.Unavailable };
    }

    const { data } = await getPrescriptionPdf(pdfAccess);

    return { status: PdfDownloadStatus.Success, blob: data };
  } catch (error) {
    console.error(error);

    return { status: statusFromError(error) };
  }
};

export default downloadPrescriptionPdf;
